const ICON_BASE_PATH = '/service-icons/';
export const DEFAULT_SERVICE_ICON = `${ICON_BASE_PATH}default.svg`;

export const getServiceIconAsset = (iconName?: string | null) => {
  if (!iconName) {
    return DEFAULT_SERVICE_ICON;
  }

  const normalized = iconName.replace(/\.svg$/i, '');
  return `${ICON_BASE_PATH}${normalized}.svg`;
};
